/* NIM-3808 Alya GLP-1 video band. A clip's source is attached only when the
   card nears the viewport, plays muted while visible and pauses off-screen.
   Under prefers-reduced-motion nothing autoplays: a play button is shown. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function attach(v) {
    if (!v.getAttribute('src') && v.dataset.aglSrc) { v.src = v.dataset.aglSrc; v.load(); }
  }
  function play(v) {
    attach(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () { showPlay(v, true); });
  }
  function showPlay(v, on) {
    var b = v.parentNode.querySelector('.agl-video-play');
    if (b) b.hidden = !on;
  }

  function init(root) {
    var vids = Array.prototype.slice.call(root.querySelectorAll('.agl-video-el'));
    if (!vids.length) return;

    vids.forEach(function (v) {
      var frame = v.parentNode;
      var sound = frame.querySelector('.agl-video-sound');
      var playBtn = frame.querySelector('.agl-video-play');
      v.addEventListener('play', function () { showPlay(v, false); });
      v.addEventListener('pause', function () { if (v.dataset.aglVisible === '1') showPlay(v, true); });
      if (playBtn) playBtn.addEventListener('click', function () { v.dataset.aglUser = '1'; play(v); });
      v.addEventListener('click', function () {
        if (v.paused) { v.dataset.aglUser = '1'; play(v); } else { v.dataset.aglUser = ''; v.pause(); }
      });
      if (sound) sound.addEventListener('click', function () {
        var turnOn = v.muted;
        vids.forEach(function (o) {
          o.muted = true;
          var s = o.parentNode.querySelector('.agl-video-sound');
          if (s) { s.setAttribute('aria-pressed', 'false'); s.setAttribute('aria-label', 'Turn sound on'); }
        });
        if (turnOn) {
          v.muted = false;
          sound.setAttribute('aria-pressed', 'true');
          sound.setAttribute('aria-label', 'Turn sound off');
          if (v.paused) { v.dataset.aglUser = '1'; play(v); }
        }
      });
      if (reduce) showPlay(v, true);
    });

    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { attach(v); if (!reduce) play(v); });
      return;
    }
    var near = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { attach(e.target); near.unobserve(e.target); } });
    }, { rootMargin: '300px 0px' });
    var seen = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        v.dataset.aglVisible = e.isIntersecting ? '1' : '';
        if (e.isIntersecting) {
          if (!reduce || v.dataset.aglUser === '1') play(v);
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { threshold: 0.5 });
    vids.forEach(function (v) { near.observe(v); seen.observe(v); });
  }

  function boot() {
    document.querySelectorAll('.agl-video').forEach(function (root) {
      if (root.dataset.aglInit) return;
      root.dataset.aglInit = '1';
      init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
